import Cookies from '../helper/cookiesHelper';

export default {
  data() {
    return {
      callCenterInterval: '',
    };
  },
  methods: {
    runValidateCallCenterTab() {
      this.callCenterInterval = setInterval(this.validateCallCenterTab, 3000);
    },
    validateCallCenterTab() {
      if (!window.name) {
        window.name = Math.random().toString();
      }

      if (
        !Cookies.getCookie('ic_window_id') ||
        window.name === Cookies.getCookie('ic_window_id')
      ) {
        // This means they are using just one tab. Set/clobber the cookie to prolong the tab's validity.
        Cookies.setCookie('ic_window_id', window.name, 4);
      } else if (Cookies.getCookie('ic_window_id') !== window.name) {
        this.$bvModal.show('prevent-multiple-tabs');
        // this means another browser tab is open, alert them to close the tabs until there is only one remaining
        clearInterval(this.callCenterInterval);
      }
    },
    onPreventMultipleTabsInfoClose() {
      this.$destroy();
    },
  },
};
